import { Button, InlineError, Input } from 'avo-ui'
import Datepicker from 'components/commons/datepicker'
import TabToggle from 'components/commons/tab-toogle'
import Timepicker from 'components/commons/timepicker'
import moment from 'moment'

export const GeneralVoting = ({ data, tempDate, errorForm, onChangeForm, onSubmit, isLoading }) => {
    return (
        <>
            <TabToggle
                title={'General'}
                content={
                    <div className={'flex flex-col space-y-16'}>
                        <div className={'flex w-1/2 flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Nama Award</div>
                            <Input
                                className={'flex-1'}
                                name={'name'}
                                placeholder={'Masukkan nama award'}
                                value={data?.name}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.name} />
                        </div>
                        <div className={'flex space-x-16'}>
                            <div className={'flex-1 flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Start Date & Time</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'start_date'}
                                        className={'flex-1'}
                                        value={tempDate?.start_date}
                                        minDate={moment()}
                                        onChange={(value) => onChangeForm({ name: 'start_date', value })}
                                        format={'YYYY-MM-DD'}
                                    />
                                    <Timepicker
                                        className={'flex-1'}
                                        name={'start_time'}
                                        placeholder='Pilih Waktu'
                                        value={tempDate?.start_time}
                                        disabled={!tempDate?.start_date}
                                        onChange={(value) => onChangeForm(value)}
                                    />
                                </div>
                                <InlineError className='mt-2' message={errorForm?.start_date} />
                            </div>
                            <div className={'flex-1 flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>End Date & Time</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'end_date'}
                                        className={'flex-1'}
                                        value={tempDate?.end_date}
                                        minDate={moment()}
                                        onChange={(value) => onChangeForm({ name: 'end_date', value })}
                                        format={'YYYY-MM-DD'}
                                    />
                                    <Timepicker
                                        className={'flex-1'}
                                        name={'end_time'}
                                        placeholder='Pilih Waktu'
                                        value={tempDate?.end_time}
                                        disabled={!tempDate?.end_date}
                                        onChange={(value) => onChangeForm(value)}
                                    />
                                </div>
                                <InlineError className='mt-2' message={errorForm?.end_date} />
                            </div>
                        </div>
                    </div>
                }
            />
            <div className={'flex py-3 justify-center'}>
                <Button className={'w-[200px]'} loading={isLoading} title={'Submit'} onClick={onSubmit} />
            </div>
        </>
    )
}
